module.exports = __webpack_public_path__ + "static/media/online.ab115655.png";